// TEAMS Website - Projects Data
// Project information with unique design variations
export const collaborations = [
  {
    slug: 'italico-splendore',
    title: {
      en: 'Italico Splendore',
      it: 'Italico Splendore'
    },
    subtitle: {
      en: 'Early Music Ensemble - Baroque, Classical and Pre-Romantic Repertoire',
      it: 'Ensemble di Musica Antica - Repertorio Barocco, Classico e Pre-Romantico'
    },
    description: {
      en: 'Baroque ensemble founded in 2010 by brothers Claudio Carmelo Andriani (violin) and Alessandro Andriani (cello). Specialises in 17th-18th century Italian repertoire with an ongoing series of critically acclaimed recordings including Vitali complete works on Tactus (6 CDs) and Sammartini on Dynamic.',
      it: 'Ensemble barocco fondato nel 2010 dai fratelli Claudio Carmelo Andriani (violino) e Alessandro Andriani (violoncello). Specializzato in repertorio italiano del XVII-XVIII secolo con una serie ininterrotta di registrazioni acclamate dalla critica, tra cui le opere complete di Vitali su Tactus (6 CD) e Sammartini su Dynamic.'
    },
    fullDescription: {
      en: 'The love and interest in early music in the Baroque, Classical, and Pre-Romantic repertoire is the core around which the Ensemble Italico Splendore was born and formed. Since its inception in 2010, the ensemble has directed its activity primarily in this direction: constant and in-depth research on sources and a meticulous philological approach.\n\nThe ensemble members\' goal is to conduct research work to bring little-frequented repertoires to light, rediscover still unknown authors, work on ancient manuscripts, giving new life to hidden musical treasures from a period when the splendor of Italian musical art was a source of pride in European courts.\n\nItalico Splendore\'s activity is oriented in two main directions: production and staging of musical performances, and musicological research and study. Musical production has already been expressed through regular concert activity at important seasons and music festivals, as well as in the realization of recording projects for labels such as Dynamic, Brilliant Classics, and Novantiqua Records.\n\nThe purely chamber music setting underlies the artistic-musical organization and the identification of objectives and guidelines in the group\'s management. All members collaborate in full harmony, bringing their human and professional contribution as well as artistic, coordinated by artistic director Alessandro Andriani and his brother Claudio, first violin concertmaster.\n\nAll group members, referring to the study of performance practice indicated by the period\'s treatises, play on original or faithful copies of period instruments, using gut strings, philological bows, historical keyboards, and original wind instruments, to faithfully reproduce the sound nuances required by composers. In the field of musicological research, Italico Splendore has set itself the goal of finding and enhancing unpublished or little-explored musical material.',
      it: 'L\'amore e l\'interesse per la musica antica nel repertorio barocco, classico e preromantico, sono il nucleo attorno al quale nasce e si forma l\'Ensemble Italico Splendore, che fin dagli esordi, nel 2010, indirizza la propria attività principalmente in tal senso: un costante e approfondito lavoro di ricerca sulle fonti e uno scrupoloso approccio filologico.\n\nIl proposito dei componenti dell\'ensemble è quello di effettuare un lavoro di ricerca affinché si possano riportare alla luce repertori poco frequentati, riscoprire autori ancora sconosciuti, operare su antichi manoscritti, dando nuova vita a tesori musicali nascosti di un periodo nel quale lo splendore dell\'arte musicale italiana era motivo di vanto nelle corti europee.\n\nL\'attività di Italico Splendore si orienta in due direzioni principali: produzione e allestimento di spettacoli musicali, e ricerca e studio musicologici. La produzione musicale si è già espressa attraverso una regolare attività concertistica presso importanti stagioni e festivals musicali, nonché nella realizzazione di progetti discografici per etichette quali Dynamic, Brilliant Classics e Novantiqua Records.\n\nL\'impostazione prettamente cameristica sta alla base della organizzazione artistico-musicale e dell\'individuazione di obiettivi e linee guida nella gestione del gruppo. Tutti i componenti collaborano in piena sintonia, apportando il proprio contributo umano e professionale oltre che artistico, coordinati dal direttore artistico Alessandro Andriani e dal fratello Claudio, primo violino concertatore.\n\nTutti gli esponenti del gruppo, rifacendosi allo studio della prassi esecutiva indicata dalla trattatistica del periodo, suonano su originali o copie fedeli di strumenti dell\'epoca, con l\'utilizzo di corde di budello, archetti filologici, tastiere storiche, e strumenti a fiato originali, per riprodurre fedelmente le sfumature sonore richieste dai compositori. Nel campo della ricerca musicologica, Italico Splendore si è posto l\'obiettivo del reperimento e della valorizzazione di un materiale musicale inedito o poco esplorato.'
    },
    image: '/ensemble/italico splendore/italicosplendoreteam.jpg',
    links: {
      spotify: 'https://open.spotify.com/artist/3FUxyZBwpHL5BSP7w1NysU',
      youtube: 'https://www.youtube.com/@italicosplendore4116',
      facebook: 'https://www.facebook.com/italicosplendore/',
    },
    gallery: [
      '/ensemble/italico splendore/slideshow/11224304_591040011034573_6468175277499630503_o.jpg',
      '/ensemble/italico splendore/slideshow/andrianivilla.jpg',
      '/ensemble/italico splendore/slideshow/italicosplendoreteam.jpg',
      '/ensemble/italico splendore/slideshow/italicosplendorevilla.jpg',
      '/ensemble/italico splendore/slideshow/italicovestiti.jpg'
    ],
    accentColor: '#8b5cf6', // Purple
    fontFamily: 'Playfair Display', // Classic serif
    tags: ['Early Music', 'Baroque', 'Classical'],
    category: 'organized',
    date: '2010-01-01',
    location: 'Various Historic Venues, Italy',
    collaborators: [
      {
        name: 'Alessandro Andriani',
        role: 'Artistic Director'
      },
      {
        name: 'Claudio Andriani',
        role: 'First Violin Concertmaster'
      },
      {
        name: 'Mario Sollazzo',
        role: 'Organ, Harpsichord'
      },
      {
        name: 'Fabiano Merlante',
        role: 'Theorbo, Baroque Guitar'
      },
      {
        name: 'Rosita Ippolito',
        role: 'Violone'
      }
    ],
    featured: true,
    status: 'ongoing'
  },
  {
    slug: 'musica-in-villa',
    title: {
      en: 'Music in Villa',
      it: 'Musica in Villa'
    },
    subtitle: {
      en: 'Annual Summer School for Musical Interpretation and Perfection',
      it: 'Scuola Estiva Annuale di Interpretazione Musicale e Perfezionamento'
    },
    description: {
      en: 'An annual summer school project (2016-2024) organized by the "Italico Splendore" Association, featuring musical interpretation courses, masterclasses, and concerts.',
      it: 'Una scuola estiva annuale (2016-2024) organizzata dall\'Associazione "Italico Splendore", con corsi di interpretazione musicale, masterclass e concerti.'
    },
    fullDescription: {
      en: 'Music in Villa is an annual summer school initiative organized by the "Italico Splendore" Association that ran from 2016 to 2024. The project combined advanced musical training with performance opportunities through intensive summer programs held in Varese.\n\nEach year, the summer school encompassed music interpretation and perfection courses designed for students and professional musicians seeking to enhance their skills in historical performance practice and chamber music. The program featured intensive masterclasses, individual coaching sessions, ensemble rehearsals, and public concerts, creating a complete educational experience that bridges theoretical knowledge with practical application.\n\nLocated in the beautiful setting of Varese, particularly at the Giardini Estensi, Musica in Villa provided an inspiring atmosphere conducive to musical growth and artistic exchange. Each edition culminated in public concerts where participants showcased their work, and scholarship awards were presented to outstanding students, recognizing excellence and dedication.\n\nThe project successfully ran for nine consecutive years (2016-2024) before pausing in 2025 and 2026. Musica in Villa represented Italico Splendore\'s commitment to music education and the transmission of historical performance practices to new generations of musicians, making a significant impact on the early music community during its active period.',
      it: 'Musica in Villa è stata un\'iniziativa di scuola estiva annuale organizzata dall\'Associazione "Italico Splendore" che si è svolta dal 2016 al 2024. Il progetto ha combinato formazione musicale avanzata con opportunità di performance attraverso programmi intensivi estivi tenuti a Varese.\n\nOgni anno, la scuola estiva comprendeva corsi di interpretazione musicale e perfezionamento progettati per studenti e musicisti professionisti che cercavano di migliorare le loro abilità nella prassi esecutiva storica e nella musica da camera. Il programma presentava masterclass intensive, sessioni di coaching individuali, prove d\'ensemble e concerti pubblici, creando un\'esperienza educativa completa che collegava la conoscenza teorica con l\'applicazione pratica.\n\nSituata nella splendida cornice di Varese, in particolare ai Giardini Estensi, Musica in Villa forniva un\'atmosfera ispiratrice favorevole alla crescita musicale e allo scambio artistico. Ogni edizione culminava in concerti pubblici dove i partecipanti mostravano il loro lavoro, e venivano assegnate borse di studio agli studenti eccellenti, riconoscendo l\'eccellenza e la dedizione.\n\nIl progetto si è svolto con successo per nove anni consecutivi (2016-2024) prima di interrompersi nel 2025 e 2026. Musica in Villa ha rappresentato l\'impegno di Italico Splendore per l\'educazione musicale e la trasmissione delle prassi esecutive storiche alle nuove generazioni di musicisti, avendo un impatto significativo sulla comunità della musica antica durante il suo periodo di attività.'
    },
    image: '/projects/music-in-villa/giardinivilla.jpg',
    gallery: [
      '/projects/music-in-villa/slideshow/11224304_591040011034573_6468175277499630503_o.jpg',
      '/projects/music-in-villa/slideshow/andrianivilla.jpg',
      '/projects/music-in-villa/slideshow/musicinvilla-summerschool2019.jpg',
      '/projects/music-in-villa/slideshow/teachingstudents.jpg',
      '/projects/music-in-villa/slideshow/tehilateching.jpg'
    ],
    accentColor: '#059669', // Emerald
    fontFamily: 'Dancing Script', // Classic handwriting style
    tags: ['Education', 'Early Music', 'Masterclass'],
    category: 'organized',
    date: '2016-07-01',
    endDate: '2024-07-31',
    location: 'Auditorium Civico Liceo Musicale "R.Malipiero", Via Garibaldi 4, Varese, Italy',
    links:{
      website: 'http://www.musicainvilla.com/',
    },
    collaborators: [
      {
        name: 'Italico Splendore',
        role: 'Organizing Body'
      },
      {
        name: 'Municipality of Varese',
        role: 'Institutional Support'
      },
      {
        name: 'Giardini Estensi',
        role: 'Venue Partner'
      }
    ],
    featured: true,
    status: 'completed'
  },
  {
    slug: 'maia',
    title: {
      en: 'Project Maia',
      it: 'Progetto Maia'
    },
    subtitle: {
      en: 'Contemporary Musical Innovation',
      it: 'Innovazione Musicale Contemporanea'
    },
    description: {
      en: 'A forward-looking musical project dedicated to contemporary composition and innovative performance practices.',
      it: 'Un progetto musicale orientato al futuro dedicato alla composizione contemporanea e alle pratiche esecutive innovative.'
    },
    fullDescription: {
      en: 'Project Maia represents a bold venture into the world of contemporary music, focusing on the creation and performance of new works that push the boundaries of musical expression. The project serves as a platform for collaboration between composers, performers, and audiences interested in exploring the cutting edge of musical innovation.\n\nThe initiative encompasses several key components: commissioning new compositions from emerging and established composers, developing innovative performance techniques that incorporate both traditional and extended instrumental methods, and creating immersive concert experiences that challenge conventional presentation formats. The project also includes educational components, workshops, and outreach activities designed to engage new audiences with contemporary classical music.\n\nProject Maiatori is characterized by its interdisciplinary approach, often incorporating elements from other art forms such as visual arts, theater, and digital media to create multisensory musical experiences. The project maintains a commitment to artistic excellence while embracing experimental approaches that reflect the diverse and evolving nature of contemporary musical expression.\n\nThrough performances, recordings, and educational initiatives, Project Maiatori aims to contribute to the ongoing development of classical music, ensuring its relevance and vitality in the 21st century while building bridges between different musical traditions and audiences.',
      it: 'Il Progetto Maia rappresenta un\'audace avventura nel mondo della musica contemporanea, concentrandosi sulla creazione e esecuzione di nuove opere che spingono i confini dell\'espressione musicale. Il progetto serve come piattaforma per la collaborazione tra compositori, interpreti e pubblico interessato a esplorare il taglio avanzato dell\'innovazione musicale.\n\nL\'iniziativa comprende diversi componenti chiave: commissionare nuove composizioni da compositori emergenti e affermati, sviluppare tecniche esecutive innovative che incorporano sia metodi strumentali tradizionali che estesi, e creare esperienze concertistiche immersive che sfidano i formati di presentazione convenzionali. Il progetto include anche componenti educativi, workshop e attività di outreach progettate per coinvolgere nuovi pubblico con la musica classica contemporanea.\n\nIl Progetto Maiatori è caratterizzato dal suo approccio interdisciplinare, incorporando spesso elementi da altre forme d\'arte come arti visive, teatro e media digitali per creare esperienze musicali multisensoriali. Il progetto mantiene un impegno verso l\'eccellenza artistica abbracciando allo stesso tempo approcci sperimentali che riflettono la natura diversificata e in evoluzione dell\'espressione musicale contemporanea.\n\nAttraverso esecuzioni, registrazioni e iniziative educative, il Progetto Maiatori mira a contribuire allo sviluppo continuo della musica classica, assicurando la sua rilevanza e vitalità nel 21° secolo costruendo allo stesso tempo ponti tra diverse tradizioni musicali e pubblico.'
    },
    image: 'https://placehold.co/1200x600/ea580c/ea580c?text=Maiatori&font=Inter',
    gallery: [
    ],
    links: {
    },
    accentColor: '#ea580c', // Orange
    fontFamily: 'Inter', // Modern sans-serif
    tags: ['Contemporary', 'Innovation', 'New Music', 'Interdisciplinary', 'Experimental'],
    category: 'organized',
    date: '2020-01-01',
    location: 'Various contemporary music venues',
    collaborators: [
     // todo add names of leaders
    ],
    featured: true,
    status: 'ongoing'
  },
]


export const projects = [
   {
    slug: 'cms-insubria',
    title: {
      en: 'CMS Insubria',
      it: 'CMS Insubria'
    },
    subtitle: {
      en: 'Teaching Education School',
      it: 'Scuola di Educazione all\'Insegnamento'
    },
    description: {
      en: 'A teaching and education school focused on musical education with parent reviews and testimonials.',
      it: 'Una scuola di insegnamento ed educazione focalizzata sull\'educazione musicale con recensioni e testimonianze dei genitori.'
    },
    fullDescription: {
      en: 'CMS Insubria is a specialized teaching and education school established in 2004, dedicated to musical education and pedagogical excellence. The institution has built a strong reputation over two decades, serving as a cornerstone for music education in the Insubria region. With a focus on comprehensive musical development, the school offers structured programs for students of all ages and skill levels, from beginners to advanced performers.\n\nThe school\'s approach combines traditional teaching methods with innovative pedagogical techniques, ensuring that each student receives personalized attention and guidance. The faculty consists of experienced educators and professional musicians who are committed to nurturing talent and fostering musical growth. The institution prides itself on the positive feedback and reviews from parents, who consistently highlight the quality of instruction, the supportive learning environment, and the remarkable progress their children achieve.\n\nCMS Insubria maintains strong connections with the local community and regularly organizes concerts, recitals, and performances where students can showcase their skills. These events not only provide valuable performance experience but also strengthen the bond between the school and families. The institution\'s commitment to excellence has made it a trusted name in music education, with many alumni going on to pursue successful careers in music.',
      it: '"Centro Musica Suzuki" Insubria è una scuola specializzata nell\'insegnamento e nell\'educazione, fondata nel 2004 e dedicata all\'eccellenza nell\'educazione musicale e pedagogica. L\'istituzione ha costruito una solida reputazione in due decenni, servendo come pietra miliare per l\'educazione musicale nella regione Insubria. Con un focus sullo sviluppo musicale completo, la scuola offre programmi strutturati per studenti di tutte le età e livelli di abilità, dai principianti ai performer avanzati.\n\nL\'approccio della scuola combina metodi di insegnamento tradizionali con tecniche pedagogiche innovative, assicurando che ogni studente riceva attenzione personale e guida. Il corpo docente è composto da educatori esperti e musicisti professionisti impegnati a coltivare il talento e promuovere la crescita musicale. L\'istituzione si vanta del feedback positivo e delle recensioni dei genitori, che sottolineano costantemente la qualità dell\'insegnamento, l\'ambiente di apprendimento di supporto e i progressi notevoli che i loro figli raggiungono.\n\nCMS Insubria mantiene forti legami con la comunità locale e organizza regolarmente concerti, recital e spettacoli dove gli studenti possono mostrare le loro abilità. Questi eventi non solo forniscono preziosa esperienza esecutiva ma rafforzano anche il legame tra la scuola e le famiglie. L\'impegno dell\'istituzione per l\'eccellenza l\'ha resa un nome affidabile nell\'educazione musicale, con molti ex-allievi che hanno intrapreso carriere di successo nella musica.'
    },
    image: '/projects/cms/teacherclaudiocms.png',
    links: {
      website: 'https://cmsinsubria.com/', 
      facebook: 'https://www.facebook.com/profile.php?id=61564615153804',
    },
    gallery: [
      '/projects/cms/slideshow/concertfinalecms.png',
      '/projects/cms/teacherclaudiocms.png'
    ],
    accentColor: '#dc2626', // Red
    fontFamily: 'Inter', // Modern sans-serif
    tags: ['Education', 'Suzuki Method'],
    category: 'organized',
    date: '2004-01-01',
    location: 'Varese, Italy',
    collaborators: [
      {
        name: 'Tehilla Meller',
        role: 'Teacher'
      },
      {
        name: 'Federica Vergani',
        role: 'Teacher'
      },
      {
        name: 'Claudio Andriani',
        role: 'Orchestra'
      },
      {
        name: 'University of Insubria',
        role: 'Academic Partnership'
      },
      {
        name: 'Municipality of Varese',
        role: 'Institutional Support'
      },
      {
        name: 'Regional Cultural Department',
        role: 'Funding Partner'
      },
    ],
    featured: true,
    status: 'ongoing'
  },
  {
    slug: 'nigun',
    title: {
      en: 'Project Nigun',
      it: 'Progetto Nigun'
    },
    subtitle: {
      en: 'Baroque Modern Chamber Music',
      it: 'Musica da Camera Barocca Moderna'
    },
    description: {
      en: 'A chamber music project exploring the intersection of baroque and modern repertoire, featuring works that bridge historical and contemporary musical languages.',
      it: 'Un progetto di musica da camera che esplora l\'intersezione tra repertorio barocco e moderno, presentando opere che collegano linguaggi musicali storici e contemporanei.'
    },
    fullDescription: {
      en: 'Project Nigun brings together three distinguished musicians - Claudio Andriani, Tehila Meller, and Roberto Villa - in a unique chamber music collaboration that bridges the baroque and modern eras. The project, active in 2018, presented two concerts that showcased innovative programming combining historical performance practice with contemporary sensibilities.\n\nThe ensemble\'s repertoire spans from baroque masterpieces to modern compositions, creating a dialogue between different musical periods while maintaining a cohesive artistic vision. This approach allows audiences to experience the evolution of musical language in a single concert setting, highlighting both the continuity and transformation of musical expression across centuries.\n\nProject Nigun represents the musicians\' commitment to artistic exploration and their ability to create meaningful connections between seemingly disparate musical traditions. The performances were noted for their technical precision, interpretive depth, and the seamless integration of diverse stylistic elements.',
      it: 'Il Progetto Nigun riunisce tre musicisti distinti - Claudio Andriani, Tehila Meller e Roberto Villa - in una collaborazione unica di musica da camera che collega le epoche barocca e moderna. Il progetto, attivo nel 2018, ha presentato due concerti che hanno mostrato una programmazione innovativa che combinava la prassi esecutiva storica con sensibilità contemporanee.\n\nIl repertorio dell\'ensemble spazia dai capolavori barocchi alle composizioni moderne, creando un dialogo tra diversi periodi musicali mantenendo una visione artistica coesa. Questo approccio permette al pubblico di sperimentare l\'evoluzione del linguaggio musicale in un unico contesto concertistico, evidenziando sia la continuità che la trasformazione dell\'espressione musicale attraverso i secoli.\n\nIl Progetto Nigun rappresenta l\'impegno dei musicisti verso l\'esplorazione artistica e la loro capacità di creare connessioni significative tra tradizioni stilistiche apparentemente diverse. Le esecuzioni sono state apprezzate per la loro precisione tecnica, profondità interpretativa e l\'integrazione senza soluzione di continuità di elementi stilistici diversificati.'
    },
    image: '/ensemble/nigun/niguntrio.jpg',
    gallery: [
      '/ensemble/nigun/instruments.jpg',
      '/ensemble/nigun/niguntrio.jpg'
    ],
    accentColor: '#059669', // Emerald
    fontFamily: 'Inter', // Modern sans-serif
    tags: ['Chamber Music', 'Contemporary', 'Crossover'],
    category: 'organized',
    date: '2018-01-01',
    location: 'Various venues in Besazio and Varese',
    collaborators: [
      {
        name: 'Claudio Andriani',
        role: 'Violin'
      },
      {
        name: 'Tehilla Meller',
        role: 'Flute'
      },
      {
        name: 'Roberto Villa',
        role: 'Collaborating Artist'
      }
    ],
    featured: true,
    status: 'completed'
  },
  {
    slug: 'quartetto-andriani',
    title: {
      en: 'Quartetto Andriani',
      it: 'Quartetto Andriani'
    },
    subtitle: {
      en: 'Family String Quartet',
      it: 'Quartetto d\'Archi Familiare'
    },
    description: {
      en: 'A family string quartet bringing together the Andriani family members in performances of classical and contemporary chamber music.',
      it: 'Un quartetto d\'archi familiare che riunisce i membri della famiglia Andriani in esecuzioni di musica da camera classica e contemporanea.'
    },
    fullDescription: {
      en: 'Quartetto Andriani is a distinguished family ensemble that showcases the remarkable musical synergy of the Andriani family. The quartet features Alessandro Andriani on cello, Tehila Meller Andriani, and Carmelo Andriani, creating a unique blend of familial connection and artistic excellence.\n\nSince its establishment in the early 2020s, the quartet has developed a reputation for its warm, cohesive sound and insightful interpretations of both classical repertoire and contemporary works. Their performances are characterized by the special chemistry that only family musicians can achieve, combined with their individual technical mastery and deep musical understanding.\n\nThe quartet\'s repertoire spans from the classical period to modern compositions, with a particular focus on works that allow for intimate musical dialogue and expressive depth. Their upcoming Carnegie Hall debut in February 2026, featuring Federico Favali\'s "Shadows of Sound – A composer portrait concert," represents a significant milestone in their international career.\n\nQuartetto Andriani is managed through the Desono Association and has already begun building an impressive discography, with recordings available on major streaming platforms including Spotify.',
      it: 'Il Quartetto Andriani è un ensemble familiare distinto che mostra la notevole sinergia musicale della famiglia Andriani. Il quartetto presenta Alessandro Andriani al violoncello, Tehila Meller Andriani e Carmelo Andriani, creando un mix unico di connessione familiare ed eccellenza artistica.\n\nDalla sua costituzione nei primi anni 2020, il quartetto ha sviluppato una reputazione per il suo suono caldo e coeso e le interpretazioni attente sia del repertorio classico che delle opere contemporanee. Le loro esecuzioni sono caratterizzate dalla chimica speciale che solo i musicisti in famiglia possono raggiungere, combinata con la loro padronanza tecnica individuale e la profonda comprensione musicale.\n\nIl repertorio del quartetto spazia dal periodo classico alle composizioni moderne, con un focus particolare su opere che permettono un dialogo musicale intimo e profondità espressiva. Il loro debutto imminente alla Carnegie Hall nel febbraio 2026, con "Shadows of Sound – A composer portrait concert" di Federico Favali, rappresenta una pietra miliare significativa nella loro carriera internazionale.\n\nIl Quartetto Andriani è gestito attraverso l\'Associazione Desono e ha già iniziato a costruire una discografia impressionante, con registrazioni disponibili sulle principali piattaforme di streaming incluso Spotify.'
    },
    image: '/ensemble/quartetto andriani/quartettoandriani.jpeg',
    gallery: [
      '/events/2026-andriani-carangiehall/quartetto-tehilla.jpeg',
      '/events/2026-andriani-carangiehall/slideshow/quartetto-tehilla e .jpeg',
      '/events/2026-andriani-carangiehall/slideshow/quartettoandriani.jpeg'
    ],
    links: {
      spotify: 'https://open.spotify.com/artist/3CeA7dmUUrV530CMDM8zy0',
    },
    accentColor: '#dc2626', // Red
    fontFamily: 'Playfair Display', // Classic serif
    tags: ['String Quartet', 'Family Ensemble', 'Classical', 'Contemporary'],
    category: 'organized',
    date: '2022-01-01',
    location: 'International venues including Carnegie Hall, New York',
    collaborators: [
      {
        name: 'Alessandro Andriani',
        role: 'Cello'
      },
      {
        name: 'Claudio Andriani',
        role: 'Viola'
      },
      {
        name: 'Carmelo Andriani',
        role: 'Violin'
      },
      {
        name: 'Federico Favali',
        role: 'Composer Collaboration'
      }
    ],
    featured: true,
    status: 'ongoing'
  },
  {
    slug: 'project-1861',
    title: {
      en: 'Project 1861',
      it: 'Progetto 1861'
    },
    subtitle: {
      en: 'Historical Musical Heritage Initiative',
      it: 'Iniziativa Patrimonio Musicale Storico'
    },
    description: {
      en: 'A research and performance project dedicated to exploring and preserving Italian musical heritage from the pivotal year of 1861.',
      it: 'Un progetto di ricerca e performance dedicato all\'esplorazione e conservazione del patrimonio musicale italiano dall\'anno cruciale del 1861.'
    },
    fullDescription: {
      en: 'Project 1861 is a significant cultural initiative that focuses on the musical landscape of Italy during the pivotal year of 1861, marking the unification of Italy. This project represents a comprehensive approach to musical research, performance, and cultural preservation, exploring how the political and social changes of the time influenced musical creation and performance practices.\n\nThe project involves extensive musicological research into composers active during this period, including both well-known figures and lesser-known musicians whose works deserve rediscovery. Through careful study of original manuscripts, historical documents, and period instruments, the project aims to recreate authentic performances that reflect the musical aesthetic of post-unification Italy.\n\nProject 1861 includes concert performances, educational workshops, scholarly publications, and recordings that bring this important musical period to contemporary audiences. The initiative serves not only as a artistic endeavor but also as a cultural bridge, connecting modern audiences with the rich musical heritage that helped shape Italian national identity during a crucial historical moment.\n\nThe project represents a collaboration between musicologists, performers, and cultural institutions, ensuring that the research and performances maintain the highest standards of both academic rigor and artistic excellence.',
      it: 'Il Progetto 1861 è un\'iniziativa culturale significativa che si concentra sul panorama musicale dell\'Italia durante l\'anno cruciale del 1861, segnando l\'unificazione dell\'Italia. Questo progetto rappresenta un approccio completo alla ricerca musicale, performance e conservazione culturale, esplorando come i cambiamenti politici e sociali del tempo abbiano influenzato la creazione musicale e le prassi esecutive.\n\nIl progetto coinvolge estese ricerche musicologiche sui compositori attivi durante questo periodo, includendo sia figure ben note che musicisti meno conosciuti le cui opere meritano di essere riscoperte. Attraverso attento studio di manoscritti originali, documenti storici e strumenti d\'epoca, il progetto mira a ricreare esecuzioni autentiche che riflettano l\'estetica musicale dell\'Italia post-unificazione.\n\nIl Progetto 1861 include esecuzioni concertistiche, workshop educativi, pubblicazioni accademiche e registrazioni che portano questo importante periodo musicale al pubblico contemporaneo. L\'iniziativa serve non solo come sforzo artistico ma anche come ponte culturale, collegando il pubblico moderno con il ricco patrimonio musicale che ha contribuito a formare l\'identità nazionale italiana durante un momento storico cruciale.\n\nIl progetto rappresenta una collaborazione tra musicologi, interpreti e istituzioni culturali, assicurando che la ricerca e le esecuzioni mantengano i più alti standard sia di rigore accademico che di eccellenza artistica.'
    },
    image: '/ensemble/1861/1861.png',
    gallery: [
      '/ensemble/1861/1861.jpeg',
    ],
    links: {
      
    },
    accentColor: '#7c3aed', // Violet
    fontFamily: 'Playfair Display', // Classic serif
    tags: ['Italian Heritage', '19th Century', 'Musicology'],
    category: 'organized',
    date: '2027-01-01',
    location: 'Various Italian cultural institutions',
    collaborators: [
      //1. claudio andriani
      //2. 
    ],
    featured: true,
    status: 'ongoing'
  },
  
];


// Helper function to get all unique tags
export const getAllTags = () => {
  const tags = new Set();
  projects.forEach(project => {
    project.tags.forEach(tag => tags.add(tag));
  });
  return Array.from(tags);
};

// Helper function to get all unique categories
export const getAllCategories = () => {
  const categories = new Set();
  projects.forEach(project => {
    categories.add(project.category);
  });
  return Array.from(categories);
};

// Asset path processing for subdirectory deployment
import { convertAssetPath } from '../utils/assetPath.js';

/**
 * Processes a project object to convert all image paths
 * @param {Object} project - The project object
 * @returns {Object} - The processed project object
 */
export const processProject = (project) => {
  if (!project) return project;
  
  const processedProject = { ...project };
  
  // Convert main image
  if (processedProject.image) {
    processedProject.image = convertAssetPath(processedProject.image);
  }
  
  // Convert gallery images
  if (processedProject.gallery && Array.isArray(processedProject.gallery)) {
    processedProject.gallery = processedProject.gallery.map(convertAssetPath);
  }
  
  return processedProject;
};

/**
 * Processes an array of projects
 * @param {Array} projects - Array of project objects
 * @returns {Array} - Array of processed project objects
 */
export const processProjects = (projects) => {
  if (!Array.isArray(projects)) return projects;
  return projects.map(processProject);
};

// Process all projects to convert image paths
export const processedProjects = processProjects(projects);

// Update existing helper functions to use processed data
export const getFeaturedProjects = () => {
  return processedProjects.filter(project => project.featured);
};

export const getProjectBySlug = (slug) => {
  const project = projects.find(p => p.slug === slug);
  return project ? processProject(project) : null;
};

export const getProjectsByCategory = (category) => {
  return processedProjects.filter(project => project.category === category);
};

export const getRelatedProjects = (currentProject, limit = 3) => {
  if (!currentProject) return [];
  
  return processedProjects
    .filter(project => 
      project.slug !== currentProject.slug && 
      (project.category === currentProject.category || 
       project.tags?.some(tag => currentProject.tags?.includes(tag)))
    )
    .slice(0, limit);
};

export const getProjectsByPerformer = (performer) => {
  return processedProjects.filter(project => 
    project.performers?.some(p => p.toLowerCase().includes(performer.toLowerCase()))
  );
};

export const getRecentProjects = (limit = 6) => {
  return processedProjects
    .sort((a, b) => new Date(b.date || '1970-01-01') - new Date(a.date || '1970-01-01'))
    .slice(0, limit);
};

export const filterProjects = ({ category, performer, featured } = {}) => {
  let filteredProjects = [...processedProjects];

  if (category) {
    filteredProjects = filteredProjects.filter(project => project.category === category);
  }

  if (performer) {
    filteredProjects = filteredProjects.filter(project => 
      project.performers?.some(p => p.toLowerCase().includes(performer.toLowerCase()))
    );
  }

  if (featured !== undefined) {
    filteredProjects = filteredProjects.filter(project => project.featured === featured);
  }

  return filteredProjects.sort((a, b) => new Date(b.date || '1970-01-01') - new Date(a.date || '1970-01-01'));
};

export const getProjectCategories = () => {
  const categories = [...new Set(projects.map(project => project.category).filter(Boolean))];
  return categories.sort();
};

export const getProjectPerformers = () => {
  const performers = [...new Set(projects.flatMap(project => project.performers || []))];
  return performers.sort();
};

// Export the processed projects array as default
export default processedProjects;
